import { render, staticRenderFns } from "./BzActiveChip.vue?vue&type=template&id=10b54028&scoped=true&"
import script from "./BzActiveChip.vue?vue&type=script&lang=js&"
export * from "./BzActiveChip.vue?vue&type=script&lang=js&"
import style0 from "./BzActiveChip.vue?vue&type=style&index=0&id=10b54028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b54028",
  null
  
)

export default component.exports